exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge-success[data-v-63f20bea] {\n  background-color: #28a745; /* Custom green background for 'Active' badge */\n}\n.card-header[data-v-63f20bea] {\n  background-color: #17a2b8 !important; /* Customize the header background */\n}\n", ""]);

// exports
